import React from 'react'
import styled from 'styled-components'
import { navigate } from 'gatsby'

import { DEFAULT_LANG } from 'config/languages'

export default function LangSelector({ languages, path, isActive }) {
   function handleOnClick(lang) {
      let url
      if (lang === DEFAULT_LANG) {
         url = path
      } else {
         url = `/${lang}${path}`
      }
      navigate(url)
   }

   return (
      <Wrapper $isActive={isActive}>
         {languages.map((item) => (
            <li key={item.lang}>
               <button disabled={item.disabled} onClick={() => handleOnClick(item.lang)}>
                  {item.label}
               </button>
            </li>
         ))}
      </Wrapper>
   )
}

const Wrapper = styled.ul`
   display: grid;
   grid-template-columns: 1fr 1fr;
   row-gap: 16px;

   li {
      margin-bottom: 0;
      line-height: 1;
   }

   button {
      padding: 0;
      background-color: transparent;
      border: none;
      text-transform: uppercase;
      cursor: pointer;
      color: ${({ theme }) => (theme.darkMode ? theme.colors.white : theme.colors.accent)};
      font-weight: 600;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 2.78px;

      &:disabled {
         color: ${({ theme }) => theme.colors.grey_3};
         cursor: not-allowed;
      }
   }
`
